<!--
 * @Author: Soul
 * @Date: 2021-06-25 17:23:14
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-05-07 18:11:03
 * @Description: file content
-->
<template>
  <div class="bg">
    <BaseImg :option="{
      style: {
        margin: '12px 0 0 16px',
        alignSelf: 'flex-start',
        width: '89px',
      },
      url: 'logo.png',
    }"/>
    <div class="key-box">
      <div class="r-body">
        活动期间成交的客户，除了享受现场签约好礼外（5月8日14:00）还可参与线上抽奖
        <span class="tips1">戴森净化器，华为65寸超薄电视 米家扫地机器人等大奖</span>
        <span class="tips2">更有罗莱家纺四件套、张小泉刀具套装、九阳空气炸锅等惊喜好礼！</span>
        <span class="tips3">活动时间：4月15日-5月8日</span>
        <div class="btn" @click="submit">密钥兑换</div>
      </div>
    </div>
    <BasePaySuccessSecret></BasePaySuccessSecret>
    <BaseBtnHome></BaseBtnHome>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
    };
  },
  created() {},
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    submit() {
      this.$modal.drawForm.alert(
        {
          drawTxt: 4,
          btnTxt: '提交',
          isKey: true
        }
      ).then(async(res)=> {
        if (res.secret) {
          this.$goPage(`secretDraw?secret=${res.secret}`);
          // .then((res)=> {
          //   if(res != 'close') {
          //     this.$router.go(-1)
          //   }
          // })
        }
      })
    }
  },
};
</script>

<style lang='scss' scoped>
.bg {
  padding-bottom: 100px;
  background: url( $imgHost + 'index_top.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, linear-gradient(0deg, #FAE5C7 0%, #F6C574 100%);
  .key-box {
    margin: 247px auto 0;
    position: relative;
    z-index: 2;
    padding: 100px 34px 0;
    width: 343px;
    height: 535px;
    background: url( $imgHost + 'owner_box.png?' + $OSSVersion) 0 0 / 100% no-repeat;
    &::after {
      content: '';
      position: absolute;
      right: -15px;
      bottom: -14px;
      width: 99px;
      height: 108px;
      background: url( $imgHost + 'icon2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
    .r-body {
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      .tips1 {
        margin-top: 10px;
        padding: 0 30px;
        font-size: 15px;
        font-weight: bold;
        color: #ff7012;
      }
      .tips2 {
        padding: 0 28px;
        font-weight: bold;
        color: #ff7012;
      }
      .tips3 {
        margin-top: 10px;
        font-size: 11px;
        color: #ff9413;
      }
      .btn {
        margin: 195px auto 0;
        width: 160px;
        height: 44px;
        background: linear-gradient(180deg, #ffb842 0%, #ff7012 100%);
        box-shadow: 0px 3px 8px 0px rgba(225, 61, 36, 0.51);
        border-radius: 22px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 19px;
        letter-spacing: 3px;
        text-indent: 3px;
        // padding-left: 3px;
        @extend .flex-center-center;
      }
    }
  }
}
</style>
